module.exports = __webpack_public_path__ + "static/media/arrow-down.cd5d5cc9.svg";